import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useRef, useEffect, useState, useCallback } from 'react';
import { g400 } from '../../colors';
import DefaultTheme from './theme';
import Input from '../../input';
export var MultiInputTheme = DefaultTheme;
/*::
import type { Node } from 'react';
import type {
  OptionType,
} from '../';
import type { MultiInputThemeType } from './theme';

export type Props = {|
  options: Array<?OptionType>,
  open: boolean,
  error?: boolean,
  disabled?: boolean,
  onToggleDropdown?: any,
  onKeyDown?: any,
  onFocus?: (e: FocusEvent) => void;
  onBlur?: (e: FocusEvent) => void;
  theme?: MultiInputThemeType,
  rest?: any,
|}
*/

var MultiInput = function MultiInput(_ref
/*: Props */
) {
  var options = _ref.options,
      open = _ref.open,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? false : _ref$error,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$onToggleDropdown = _ref.onToggleDropdown,
      onToggleDropdown = _ref$onToggleDropdown === void 0 ? function () {
    return undefined;
  } : _ref$onToggleDropdown,
      _ref$onKeyDown = _ref.onKeyDown,
      onKeyDown = _ref$onKeyDown === void 0 ? function () {
    return undefined;
  } : _ref$onKeyDown,
      _ref$onFocus = _ref.onFocus,
      onFocus = _ref$onFocus === void 0 ? function () {
    return undefined;
  } : _ref$onFocus,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? function () {
    return undefined;
  } : _ref$onBlur,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? DefaultTheme : _ref$theme,
      rest = _objectWithoutPropertiesLoose(_ref, ["options", "open", "error", "disabled", "onToggleDropdown", "onKeyDown", "onFocus", "onBlur", "theme"]);

  var inputRef = useRef(null);
  var optionListEl = useRef(null);
  var calcEl = useRef(null);

  var _useState = useState({
    moreLabel: null
  }),
      moreLabel = _useState[0].moreLabel,
      setMoreLabel = _useState[1];

  useEffect(function () {
    if (optionListEl.current && calcEl.current) {
      var containerWidth = optionListEl.current.clientWidth;
      var totalChildrenWidth = 0;
      var counter = 0; // eslint-disable-next-line no-restricted-syntax

      for (var _iterator = _createForOfIteratorHelperLoose(calcEl.current.children), _step; !(_step = _iterator()).done;) {
        var child = _step.value;
        totalChildrenWidth += child.clientWidth;

        if (totalChildrenWidth > containerWidth) {
          break;
        }

        counter++;
      }

      var moreNum = options.length > 0 ? options.length - counter : 0;

      if (moreNum > 9) {
        setMoreLabel({
          moreLabel: '∞'
        });
      } else if (moreNum > 0) {
        setMoreLabel({
          moreLabel: "+" + moreNum
        });
      } else {
        setMoreLabel({
          moreLabel: null
        });
      }
    }
  }, [options]);
  var formatLabelText = useCallback(function (option
  /*: OptionType */
  ) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, option.label, ";\xA0");
  }, []);
  return /*#__PURE__*/React.createElement(theme.Main, Object.assign({
    "data-test": "select-multi-input-main"
  }, rest), /*#__PURE__*/React.createElement(Input, {
    ref: inputRef,
    onKeyDown: onKeyDown,
    onMouseDown: function onMouseDown(e) {
      return e.nativeEvent.stopImmediatePropagation();
    },
    onClick: function onClick(e) {
      if (!disabled) {
        onToggleDropdown(e);
      }

      if (inputRef.current) {
        inputRef.current.focus();
      }
    },
    onFocus: onFocus,
    onBlur: onBlur,
    readOnly: true,
    error: error,
    disabled: disabled,
    theme: theme.TextInput,
    "data-test": "select-multi-input",
    rest: {
      open: open
    }
  }), /*#__PURE__*/React.createElement(theme.DropdownControl, {
    onMouseDown: function onMouseDown(e) {
      return e.nativeEvent.stopImmediatePropagation();
    },
    onClick: function onClick(e) {
      if (!disabled) {
        onToggleDropdown(e);
      }

      if (inputRef.current) {
        inputRef.current.focus();
      }
    },
    "data-test": "select-multi-input-dropdownControl"
  }, /*#__PURE__*/React.createElement(theme.ArrowIcon, {
    color: g400(),
    direction: open ? 'top' : 'bottom',
    width: 1
  })), /*#__PURE__*/React.createElement(theme.OptionsContainer, {
    "data-test": "select-multi-input-options-container"
  }, /*#__PURE__*/React.createElement(Input, {
    ref: optionListEl,
    "data-test": "select-multi-input-options-list",
    value: options.length > 0 ? options.map(function (option) {
      return option && option.label;
    }) : '',
    theme: theme.OptionList
  }), /*#__PURE__*/React.createElement(theme.MoreNumberContainer, {
    "data-test": "select-multi-input-more-number-container"
  }, moreLabel ? /*#__PURE__*/React.createElement(theme.MoreNumber, {
    "data-test": "select-multi-input-more-number"
  }, moreLabel) : null)), /*#__PURE__*/React.createElement(theme.Calc, {
    ref: calcEl,
    "data-test": "select-multi-input-calc"
  }, options.map && options.map(function (option, idx) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement(theme.CalcItem, {
        key: idx,
        "data-test": "select-multi-input-calc-item"
      }, option && formatLabelText(option))
    );
  })));
};

export default MultiInput;